
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Web3Service } from './theme/blockchain/web3/web3.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [Web3Service]
})
export class AppComponent implements OnInit {
  public self;
  constructor(public router: Router) {
    this.setup();
  }
  timeoutID: any;

  setup() {
    var self = this;
    document.addEventListener('mousemove', function () {
      if (window.location.hash == "#/" || window.location.hash == "#/deploy" || window.location.hash == "#/forgot" || window.location.hash == "#/verification" || window.location.hash == "#/twofa") {

      }
      else {
        self.resetTimer();
      }
    });
    document.addEventListener('mousedown', function () {
      self.resetTimer();
    });
    document.addEventListener('keypress', function () {
      self.resetTimer();
    });
    document.addEventListener('DOMMouseScroll', function () {
      self.resetTimer();
    });
    document.addEventListener('mousewheel', function () {
      self.resetTimer();
    });
    document.addEventListener('touchmove', function () {
      self.resetTimer();
    });
    this.startTimer();
  }
  resetTimer() {
    window.clearTimeout(this.timeoutID);

    this.startTimer();
  }

  goInactive() {
    // do something
    // alert("InActive");
    // var self = this;
    localStorage.clear();
    // self.router.navigateByUrl('/');
    window.location.reload()

  }
  startTimer() {
    this.timeoutID = window.setTimeout(this.goInactive, 1800000);
    // this.timeoutID = window.setTimeout(this.goInactive, 10000);
  }
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
